import { useTranslation as i18nextUseTranslation } from "react-i18next";

const useTranslation = (path: string | undefined, p?: { keyPrefix?: string }) =>
  i18nextUseTranslation(path, p);

export default useTranslation;
